import React from "react";
import { Box, HStack, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import RiskReviewStatusBadge from "../common/RiskReviewStatusBadge";

const severities = ["CRITICAL", "HIGH", "MEDIUM", "LOW"];

const RiskReviewRiskSummary = ({ risks = [] }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const triggered = (risks || []).filter((risk) => risk.triggered !== false);

  return (
    <Box bg={cardBg} border="1px solid" borderColor={borderColor} borderRadius="xl" overflow="hidden">
      <Box px={4} py={3} borderBottom="1px solid" borderColor="gray.100">
        <Text color="gray.800" fontWeight="700">
          Risk Summary
        </Text>
      </Box>
      <Box px={4} py={4}>
        <VStack align="stretch" spacing={0}>
          {severities.map((severity) => (
            <HStack
              key={severity}
              justify="space-between"
              py={2}
              borderBottom={severity === "LOW" ? "0" : "1px solid"}
              borderColor="gray.100"
            >
              <RiskReviewStatusBadge value={severity} type="risk" />
              <Text color="gray.900" fontSize="lg" fontWeight="700">
                {triggered.filter((risk) => risk.severity === severity).length}
              </Text>
            </HStack>
          ))}
        </VStack>
        <Box borderTop="1px solid" borderColor="gray.100" mt={4} pt={4}>
          {triggered.length ? (
            <VStack align="stretch" spacing={3}>
              {triggered.map((risk, index) => (
                <Box key={`${risk.fieldCode}-${index}`}>
                  <Text color="gray.800" fontSize="sm" fontWeight="700">
                    {risk.triggerCode || risk.fieldCode}
                  </Text>
                  <Text color="gray.500" fontSize="sm">
                    {risk.message || risk.category || "Triggered risk"}
                  </Text>
                </Box>
              ))}
            </VStack>
          ) : (
            <Text color="gray.500" fontSize="sm">
              No triggered risks
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default RiskReviewRiskSummary;
